<template>
    <div>
        <slot v-bind="this"></slot>
    </div>
</template>

<script>
    import PageComponent from '../../../mixins/PageComponent';

    export default {

        extends: PageComponent,

        data() {
            let { referent } = this.data;

            return {
                referent
            }
        },

        methods: {
            handleReferentChanged(value) {
                this.referent = value;
            }
        }
    }
</script>